import { useQuery } from '@tanstack/react-query';
import { deliveryChargesService } from '../../services/deliveryChargesService';

export const useDeliveryChargeConfig = () => {
  return useQuery({
    queryKey: ['delivery-charge-config'],
    queryFn: () => deliveryChargesService.getConfig(),
  });
};
